<template>
  <div style="padding: 15px">
    <vxe-toolbar>
      <template #buttons>
        <el-button type="primary"  v-print="PrintOption" icon="el-icon-printer"    size="mini"  class="custom-color">打印</el-button>
     
    <!--   <el-button   icon="el-icon-printer"    size="mini"  type="primary"      @click="print"  :disabled="loading"   >打印</el-button>-->
      </template>
    </vxe-toolbar>
    <div id="printbox">
      <div class="print-row">
        <table class="print-table">
          <caption>
            <h1>{{ Title }}</h1>
            <div class="params_box">
              <div class="params_item" v-for="(i, k) in ParamsData" :key="k">
                <span>{{ i.Label }}: {{ i.Value }}</span>
              </div>
            </div>
          </caption>
          <thead class="print-thead">
            <tr>
              <th v-for="(i, k) in TableNames" :key="k" :style="'width:' + i.col.width + 'px;'">{{ i.label }}</th>
            </tr>
          </thead>
          <tbody class="print-tbody">
            <tr v-for="(i, k) in List" :key="k">
              <td v-for="(ci, ck) in TableNames" :key="ck">
                <div v-if="ci.tableName == 'Sn'">{{ k }}</div>
                <div v-else>{{ i[ci.tableName] }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Title: "",
      ParamsData: [],
      TableNames: [],
      List: [],
      PrintOption: {
        id: "printbox", // 这里是要打印元素的ID
        popTitle: "", // 打印的标题
        extraCss: "", // 打印可引入外部的一个 css 文件
        extraHead: "", // 打印头部文字
      },
      isShow: false,
    };
  },
  computed: {
    tablePrint() {
      return {
        // 自定义打印的样式示例
        style: `.vxe-table {
                    color: #000000; // 修改表格默认颜色
                    font-family: "Microsoft YaHei",微软雅黑,"MicrosoftJhengHei",华文细黑,STHeiti,MingLiu; // 修改表格默认字体
                  }
                  .vxe-table,
                  .vxe-table thead th,
                  .vxe-table tbody td,
                  .vxe-table tfoot td  {
                    border-color: #000000; // 修改表格边框颜色
                  }
                  .vxe-table thead th {
                    font-size: ${this.HeadFontSize} !important; // 修改表头默认字体大小
                  }
                  .vxe-table tbody td,
                  .vxe-table tfoot td {                  
                    font-size: ${this.BodyFontSize} !important; // 修改表格默认字体大小
                  }`,
      };
    },
  },
  mounted() { },
  methods: {
    setData(data) {
      this.isShow = false;
      console.log("setData", JSON.parse(JSON.stringify(data)));
      this.Title = data.Title;
      this.TableNames = data.TableNames;
      this.List = data.List;

      // for (let i = 1; i < 20; i++) {
      //   this.List = [...this.List, ...data.List]
      // }

      data.ParamsData.forEach(x => {
        if (x.type == "RangPicker" || x.type == "yearRangPicker") {
          var value1 = data.Params[x.field];
          var value2 = data.Params[x.field2];
          this.ParamsData.push({ Label: x.title, Value: value1 ? value1 + " - " + value2 : "" });
        } else if (x.type == 'DataInput') {
          var value1 = data.Params[x.field];
          var value2 = data.Params[x.field2];
          this.ParamsData.push({ Label: x.title, Value: value1 ? value1 + " - " + value2 : "" });
        } else if (x.type == 'ApiSelect') {
          var value = "";
          if (data.Params[x.field]) {
            var value1 = data.Params[x.field];
            var value2 = null;
            if (x.apiOptions) value2 = x.apiOptions.find(e => e[x.apiOption.value] == value1);
            if (value2) value = value2[x.apiOption.label];
          }
          this.ParamsData.push({ Label: x.title, Value: value });
        } else if (x.type == 'Select') {
          var value = "";
          var value1 = x.options.find(e => e.value == data.Params[x.field]);
          if (value1) value = value1.label;
          this.ParamsData.push({ Label: x.title, Value: value });
        } else {
          var value = data.Params[x.field] || "";
          this.ParamsData.push({ Label: x.title, Value: value });
        }
      });

      console.log('this.ParamsData', JSON.parse(JSON.stringify(this.ParamsData)));

      this.$nextTick(() => {
        this.isShow = true;
      });
    },

  },
};
</script>
<style lang="scss">
#printbox {
  border: 1px solid #ededed;
  margin: 0 auto;

  // background-color: aliceblue;
  .print-row {
    // background-color: antiquewhite;
    display: flex;
    // border: 1px solid #ededed;
    min-height: 10mm;
    width: 100%;
    font-size: 12px;

    .title {
      font-size: 24px;
      font-weight: bold;
      margin: auto;
      line-height: 50px;
    }

    .print-table {
      width: 100%;
      border-collapse: collapse;

      .params_box {
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        padding-bottom: 10px;

        .params_item {
          width: 260px;
          text-align: left;
          margin-bottom: 3px;
        }
      }

      td,
      th {
        text-align: center;
        border: 1px solid #000;
        border-collapse: collapse;
      }

      tbody tr td {
        page-break-inside: avoid;
      }
    }
  }

  .print-row+.print-row {
    border-top: none;
  }

  .custom-color {
  background-color: #FF5733; /* 自定义背景颜色 */
  border-color: #FF5733; /* 自定义边框颜色 */
  color: #FFFFFF; /* 文字颜色 */
}
}

@media print {
  #printbox {
    border: none;
  }
}
</style>